import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { getProtectedRouteDefinitions } from './resolveRouteEntry';
import { ProtectedRouteElement } from './ProtectedRouteElement';

export interface CreateProtectedRouteElementsOptions {
  getInitialPath: () => string;
  notFoundElement: React.ReactNode;
  excludePaths?: string[];
  onlyPaths?: string[];
  includeFallbackRoutes?: boolean;
}

export const createProtectedRouteElements = ({
  getInitialPath,
  notFoundElement,
  excludePaths = [],
  onlyPaths,
  includeFallbackRoutes = true,
}: CreateProtectedRouteElementsOptions): React.ReactNode[] => {
  const definitions = getProtectedRouteDefinitions().filter((definition) => {
    if (onlyPaths) {
      return onlyPaths.includes(definition.path);
    }
    if (excludePaths.includes(definition.path)) {
      return false;
    }
    return true;
  });

  const routeElements = definitions.map((definition) => {
    if (definition.redirectTo) {
      return (
        <Route
          key={definition.path}
          path={definition.path}
          element={
            <ProtectedRouteElement>
              {definition.element ?? <Navigate to={definition.redirectTo} replace />}
            </ProtectedRouteElement>
          }
        />
      );
    }

    return (
      <Route
        key={definition.path}
        path={definition.path}
        element={<ProtectedRouteElement>{definition.element}</ProtectedRouteElement>}
      />
    );
  });

  if (!includeFallbackRoutes) {
    return routeElements;
  }

  return [
    ...routeElements,
    <Route
      key="/"
      path="/"
      element={<Navigate to={getInitialPath()} replace />}
    />,
    <Route
      key="*"
      path="*"
      element={<ProtectedRouteElement>{notFoundElement}</ProtectedRouteElement>}
    />,
  ];
};
